import React from 'react';
import App from './App';
import { useErrorContext } from './Error/ErrorContext';
import { setupFetchInterceptor } from './Error/axiosInterceptor';
import { NotificationService } from './services/notificationService';
import * as serviceWorkerRegistration from './registerServiceWorker';

function scheduleDeferredBrowserTask(task: () => void, fallbackDelay = 1200) {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const requestIdleCallback = window.requestIdleCallback?.bind(window);
  const cancelIdleCallback = window.cancelIdleCallback?.bind(window);

  if (requestIdleCallback) {
    const idleId = requestIdleCallback(() => task());
    return () => {
      if (cancelIdleCallback) {
        cancelIdleCallback(idleId);
      }
    };
  }

  const timeoutId = window.setTimeout(task, fallbackDelay);
  return () => {
    window.clearTimeout(timeoutId);
  };
}

export default function AppWithInterceptor() {
  const { setError, setRequestDetails, setServerErrorDetails } = useErrorContext();

  React.useEffect(() => {
    // Interceptor nur einmal einrichten
    setupFetchInterceptor(setError, setRequestDetails, setServerErrorDetails);
  }, [setError, setRequestDetails, setServerErrorDetails]);

  React.useEffect(() => {
    const cancelNotificationInit = scheduleDeferredBrowserTask(() => {
      NotificationService.initialize().then((success) => {
        if (success) {
          console.log('✅ NotificationService erfolgreich initialisiert');
        } else {
          console.log('ℹ️ NotificationService nicht verfügbar (normal für Tablets oder nicht unterstützte Browser)');
        }
      }).catch((error) => {
        console.warn('⚠️ Fehler bei NotificationService Initialisierung:', error);
      });
    });

    const cancelServiceWorkerRegister = scheduleDeferredBrowserTask(() => {
      serviceWorkerRegistration.register();
    }, 2000);

    return () => {
      cancelNotificationInit();
      cancelServiceWorkerRegister();
    };
  }, []);

  return <App />;
}
